/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, Divider, Avatar, ButtonBase, Tooltip } from '@mui/material';
import IconMenu2 from '@mui/icons-material/KeyboardDoubleArrowRight';
import IconMenu3 from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { ReactComponent as NonSelectedLogoutIcon } from '../../../assets/images/icons/sidemenu/Log-Out line  1.svg';
import { ReactComponent as SelectedLogoutIcon } from '../../../assets/images/icons/sidemenu/Log-Out line  3.svg';
import MenuList from './MenuList';
import LogoSection from '../LogoSection/copy';
import { useState } from 'react';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar2 = ({ drawerOpen, drawerToggle, isLoading }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); //for mobile
    const isTablet = useMediaQuery(theme.breakpoints.up('sm')); //for tablet and desktop
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const value = 'false';
    const show = false;
    const [hovered, setHovered] = useState(false);

    const handleLogout = () => {
        try {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('change_password');
            // navigate('/login', { replace: true });
            window.location.replace('/login');

        } catch (error) {
            console.error('Logout failed:', error); // Optional: show user feedback (e.g., Snackbar or alert)
        }
    };

    const drawer = (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 100, height: 95 }}>
                    <LogoSection showheading={show} />
                </Box>
            </Box>
            {isTablet && ( //for desktop and tablet
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100px',
                            height: '80px !important',
                            padding: '0 16px'
                        }}
                    >
                        <div>
                            <LogoSection isLoading={isLoading} />
                        </div>
                    </Box>
                    <Divider className="MarginBottom20px gradient-divider-sidebar" />
                    <Box
                        style={{
                            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                            paddingLeft: '16px',
                            marginTop: '15px',
                            paddingRight: '16px'
                        }}
                    >
                        <MenuList />
                    </Box>
                    <Divider className="MarginTop2px MarginBottom10px gradient-divider-sidebar" />
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '16px',
                            paddingLeft: '0px',
                            paddingRight: '16px',
                            marginLeft: '20px',
                            paddingBottom: '20px'
                        }}
                    >
                        <Tooltip
                            title={
                                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <span>Logout</span>
                                </span>
                            }
                            arrow
                            placement="right"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        fontFamily: 'Open Sans Regular',
                                        backgroundColor: '#D9EAFF', // white background
                                        color: '#03045e', // text color
                                        fontSize: '14px', // adjust size as needed
                                        borderRadius: '8px',
                                        padding: '8px 12px',
                                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' // smooth shadow
                                    }
                                },
                                arrow: {
                                    sx: {
                                        color: '#D9EAFF' // match background color
                                    }
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent:'center',
                                    cursor: 'pointer',
                                    height: '40px',
                                    width:'68px',
                                    borderRadius: '8px',
                                    background: hovered ? '#D9EAFF' : 'transparent'
                                }}
                                onMouseEnter={() => setHovered(true)}
                                onMouseLeave={() => setHovered(false)}
                                onClick={() => handleLogout()}
                            >
                                <Avatar
                                    variant="rounded"
                                    sx={{
                                        width: '34px',
                                        height: '34px',
                                        fontSize: '1.2rem',
                                        cursor: 'pointer',
                                        borderRadius: '12px',
                                        /* stylelint-disable-next-line order/properties-order */
                                        transition: 'all .2s ease-in-out',
                                        background: 'transparent',
                                        // marginRight: '10px' // Add margin between icon and text
                                    }}
                                >
                                    {hovered ? <SelectedLogoutIcon /> : <NonSelectedLogoutIcon />}
                                </Avatar>
                            </Box>
                        </Tooltip>
                    </Box>
                </>
            )}
            {isMobile && ( // for mobile
                <Box sx={{ px: 2 }}>
                    <MenuList />
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => handleLogout()}>
                        <Avatar
                            variant="rounded"
                            sx={{
                                ...theme.typography.commonAvatar,
                                ...theme.typography.mediumAvatar,
                                /* stylelint-disable-next-line order/properties-order */
                                transition: 'all .2s ease-in-out',
                                background: 'transparent',
                                marginRight: '10px', // Add margin between icon and text
                                '&:hover': {
                                    background: theme.palette.secondary.dark,
                                    color: theme.palette.secondary.light
                                }
                            }}
                        >
                            <NonSelectedLogoutIcon />
                        </Avatar>
                    </Box>
                </Box>
            )}
        </>
    );
    return (
        <>
            <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? '100px' : 'auto' }} aria-label="mailbox folders">
                <Box
                    sx={{
                        width: '15px',
                        display: { xs: 'none', md: 'none', lg: 'flex' },
                        [theme.breakpoints.down('md')]: {
                            width: 'auto'
                        }
                    }}
                >
                    <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                        <LogoSection isLoading={isLoading} />
                    </Box>
                    <ButtonBase aria-label="drawertoggle" sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <Avatar
                            variant="rounded"
                            aria-label="drawertoggleavatar3"
                            sx={{
                                ...theme.typography.commonAvatar,
                                ...theme.typography.mediumAvatar,
                                /* stylelint-disable-next-line order/properties-order */
                                transition: 'all .2s ease-in-out',
                                background: theme.palette.secondary.light,
                                color: theme.palette.secondary.dark,
                                '&:hover': {
                                    background: theme.palette.secondary.dark,
                                    color: theme.palette.secondary.light
                                }
                            }}
                            color="inherit"
                        >
                            {value ? <IconMenu2 stroke={1.5} size="1.3rem" /> : <IconMenu3 stroke={1.5} size="1.3rem" />}
                        </Avatar>
                    </ButtonBase>
                </Box>
                <Drawer
                    variant={matchUpMd ? 'persistent' : 'temporary'}
                    anchor="left"
                    open={drawerOpen}
                    onClose={drawerToggle}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: '100px',
                            borderRadius: '0px 20px 20px 0px', // border-radius style
                            background: '#FFF', // background style
                            boxShadow: '4px 4px 5px 0px rgba(57, 57, 57, 0.25)', // box-shadow style
                            color: theme.palette.text.primary,
                            borderRight: 'none',
                            top: '0px', // Adjust top positioning
                            [theme.breakpoints.up('md')]: {
                                top: '0px' // Adjust top positioning for md and above
                            }
                            // [theme.breakpoints.between('sm', 'lg')]: {
                            //     overflow: 'hidden'
                            // }
                        }
                    }}
                    // ModalProps={{ keepMounted: true }}
                    color="inherit"
                >
                    {isLoading === true ? drawer : drawer}
                </Drawer>
            </Box>
        </>
    );
};

Sidebar2.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    isLoading: PropTypes.bool
};

export default Sidebar2;
